import { HttpClient, HttpHeaders } from "@angular/common/http";
import { EventEmitter, Injectable } from "@angular/core";

import { firstValueFrom } from "rxjs";

import { SearchCriteriaType } from "@common/plants.types";

import { AccumulatedSearchResult } from "@models/AccumulatedSearchResult";

import { AppConfig } from "../app.config";

@Injectable({ providedIn: "root" })
export class FetchService {
  private serviceUrl: string;
  private headers: HttpHeaders = new HttpHeaders({
    "Content-Type": "application/json"
  });

  public serviceCallFailed$ = new EventEmitter();

  constructor(
    private appConfig: AppConfig,
    private http: HttpClient
  ) {
    this.serviceUrl = this.appConfig.getPlantsAPIUrl();
  }

  async fetchPlantsSearchResults(
    searchCriteria: SearchCriteriaType,
    pageNumber = 1,
    allData = 0
  ): Promise<AccumulatedSearchResult> {
    const url = `${this.serviceUrl}plants-search-results`;

    const requestBody = {
      ...searchCriteria,
      pageNumber,
      allData
    };

    try {
      return await firstValueFrom(
        this.http.post<AccumulatedSearchResult>(url, requestBody, {
          headers: this.headers
        })
      );
    } catch (error) {
      return this.handleError(error);
    }
  }

  async fetchPlantsForDownload(
    searchCriteria: SearchCriteriaType,
    pageNumber = 1,
    allData = 0
  ): Promise<Blob> {
    const url = this.serviceUrl + "plants-search-results/download";
    let selectedFilters = [];

    if ("FilterOptions" in searchCriteria) {
      if (searchCriteria.FilterOptions != null && searchCriteria.FilterOptions.length > 0) {
        selectedFilters = searchCriteria.FilterOptions.flatMap((option) =>
          option.Filters.filter((filter) => filter.IsSelected)
        ).map((filter) => filter.Display);
      }
    }

    const requestBody = {
      ...searchCriteria,
      pageNumber,
      allData,
      selectedFilters
    };

    try {
      const response = await firstValueFrom(
        this.http.post(url, requestBody, {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            Accept: "text/csv"
          }),
          responseType: "text"
        })
      );

      return new Blob([new Uint8Array([0xef, 0xbb, 0xbf]), response], {
        type: "text/csv;charset=UTF-8"
      });
    } catch (error) {
      return this.handleError(error);
    }
  }

  private handleError(error: any): Promise<any> {
    this.serviceCallFailed$.emit();
    console.error("An error occurred", error);
    return Promise.reject(error.message || error);
  }
}
